/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { StarGroupOff, StarGroupOn, StarGroupContainer } from './styles';

interface ReviewStarsRange {
  className: string;
  large: boolean;
  score: number;
}
export const ReviewStarsRange: FunctionComponent<ReviewStarsRange> = ({
  score = 0,
  className = '',
  large = false
}) => {
  const px = large ? 20 : 16;
  const pct = (100.0 * score) / 5.0;

  return (
    <div className={className}>
      <StarGroupContainer>
        <StarGroupOff size={px} />
        <StarGroupOn size={px} percent={pct} />
      </StarGroupContainer>
    </div>
  );
};

export const ReviewStars = styled(ReviewStarsRange)<any>`
  && {
    width: 50%;
    text-align: right;
    display: inline-block;
  }
`;

export const ReviewStarsOverall = styled(ReviewStarsRange)<any>`
  && {
    display: inline-block;
    padding-right: 1em;

    @media (min-width: 500px) {
      padding-left: 1em;
    }
  }
`;

export default ReviewStarsRange;
